module.exports = __webpack_public_path__ + "media/images/ic-authority-f0eba2b874fa931ba5ed2db24d6ece6b.svg";